module.exports = __webpack_public_path__ + "img/asset-delete.f6448aa5.webp";